import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Session mode: LIVE (default) or DEMO. The backend hard-blocks all mutating
// requests carrying X-CR-Mode: DEMO.
export function getMode() {
  return sessionStorage.getItem("cr_mode") || "LIVE";
}
export function setMode(mode) {
  sessionStorage.setItem("cr_mode", mode);
}

// Attach bearer token fallback (cross-site cookies are unreliable on some browsers)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cr_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers["X-CR-Mode"] = getMode();
  return config;
});

export function getToken() {
  return localStorage.getItem("cr_token");
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
